export type BreakpointKey = 'xs' | 'rs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
// TailwindCSS breakpoints
export const BREAKPOINTS: Record<BreakpointKey, number> = {
  xs: 475,
  rs: 520,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
  '3xl': 1920
};
